// src/components/dashboard/modals/AddCourseModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { XCircleIcon } from '@heroicons/react/24/outline';

function AddCourseModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
  error,
  formData,
  onChange
}) {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    // Reset form data is handled by parent component
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-xl p-6 sm:p-8 max-w-md w-full shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-slate-800">{t('courses.modals.add.title')}</h3>
          <button
            onClick={handleClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <XCircleIcon className="w-6 h-6" />
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="courseName" className="block text-sm font-medium text-slate-700 mb-1">
              {t('courses.modals.add.courseName')} <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="courseName"
              name="name"
              value={formData.name}
              onChange={onChange}
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              placeholder={t('courses.modals.add.placeholder')}
              required
              disabled={isSubmitting}
              autoFocus
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
              disabled={isSubmitting}
            >
              {t('common.cancel')}
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-gradient-to-r from-cyan-600 to-cyan-500 text-white rounded-lg hover:from-cyan-700 hover:to-cyan-600 transition-colors disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? t('courses.modals.add.adding') : t('courses.modals.add.addButton')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCourseModal;